/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelinstagramstory4Inputs */

const en_aiflowchannelinstagramstory4 = /** @type {(inputs: Aiflowchannelinstagramstory4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram story`)
};

const de_aiflowchannelinstagramstory4 = /** @type {(inputs: Aiflowchannelinstagramstory4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Story`)
};

/**
* | output |
* | --- |
* | "Instagram story" |
*
* @param {Aiflowchannelinstagramstory4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelinstagramstory4 = /** @type {((inputs?: Aiflowchannelinstagramstory4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelinstagramstory4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelinstagramstory4(inputs)
	return de_aiflowchannelinstagramstory4(inputs)
});
export { aiflowchannelinstagramstory4 as "aiFlowChannelInstagramStory" }